import styled from "styled-components";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";
import colors from "@streeteasy/design-system/deprecated/colors";

const BaseTextArea = styled.textarea.attrs(props => ({
  disabled: props.isDisabled
}))`
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  appearance: none;
  background-color: initial;
  border: 1px solid ${colors.foxGrey};
  border-radius: 0;
  box-sizing: border-box;
  color: ${colors.whaleGrey};
  display: block;
  font: 400 14px/18px "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  height: ${props => props.height};
  padding: 15px;
  resize: ${props => props.resize};
  width: 100%;

  ${props =>
    props.isDisabled &&
    `
    color: ${colors.wolfGrey};
    background: ${colors.mouseGrey};
    border-color: ${colors.foxGrey};
  `}

  ${props =>
    props.isInvalid &&
    `
    background: rgba(237, 67, 47, 0.12);
    border-color: ${colors.errorRed};
  `}

  &::-webkit-input-placeholder {
    color: ${colors.koalaGrey};
  }

  &::-moz-placeholder {
    color: ${colors.koalaGrey};
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

BaseTextArea.displayName = "TextArea";

export default BaseTextArea;
